import { FormattedMessage, useIntl } from 'react-intl';
import { Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

type QuickLinkCardProps = {
    createHref: string;
    icon: string;
    title: string;
    viewHref: string;
};

const QuickLinkCard = (props: QuickLinkCardProps) => {

    const { createHref, icon, title, viewHref } = props;

    return (
        <Card className="h-100">
            <Card.Header className="text-uppercase">
                <i className={`fa-solid ${icon} me-2`} />
                <strong>
                    {title}
                </strong>
            </Card.Header>
            <Card.Body className="d-flex gap-2 p-2">
                <Link
                    className="btn btn-outline-primary text-uppercase flex-fill text-center"
                    style={{ letterSpacing: '1.5px' }}
                    to={createHref}
                >
                    {<FormattedMessage defaultMessage="Create" id="create.be56b47d" />}
                </Link>
                <Link
                    className="btn btn-outline-primary text-uppercase flex-fill text-center"
                    style={{ letterSpacing: '1.5px' }}
                    to={viewHref}
                >
                    {<FormattedMessage defaultMessage="View" id="view.1590505b" />}
                </Link>
            </Card.Body>
        </Card>
    );

};

export const QuickLinksTile = () => {

    const { formatMessage } = useIntl();

    return (
        <Row className="g-3">
            <Col md={6}>
                <QuickLinkCard
                    createHref="/access-codes?create=true"
                    icon="fa-key"
                    title={formatMessage({ id: 'access_codes.76e35c18', defaultMessage: 'Access Codes', description: 'menu' })}
                    viewHref="/access-codes"
                />
            </Col>
            <Col md={6}>
                <QuickLinkCard
                    createHref="/custom-tests?create=true"
                    icon="fa-pen-to-square"
                    title={formatMessage({ id: 'custom_tests.9e7494ea', defaultMessage: 'Custom Tests' })}
                    viewHref="/custom-tests"
                />
            </Col>
        </Row>
    );

};
